import { Gem } from '@lucide/vue'

import { AssetWizardFlow } from '@/store/ai/assetWizard/utils/types'

import OwnershipStep from '../components/OwnershipStep.vue'

import {
  amountField,
  assetNameField,
  currencyField,
  dateField,
  descriptionField,
  ownerAccountFields,
} from '../utils/fields'
import { SUMMARY_STEP, TAGS_STEP, VALUE_STEP } from '../utils/steps'
import { OWNERSHIP_STEP_KEY } from '../utils/const'
import { WizardDefinition } from '../utils/types'

import { fineArtSchema } from './schema'
import { create } from './create'
import { TagRef } from '@/entities/tags/utils/types'


const FINE_ART_TYPE = 'fine art and collectables'

const DEFAULT_TAGS: TagRef[] = [
  { tag_name: 'Asset Class', tag_value: 'Fine Art and Collectables' },
  { tag_name: 'Investment Strategy', tag_value: 'Fine Art' },
]

/** Art, collectables, jewellery, wine — anything held for itself rather than for yield. */
export const fineArtWizard: WizardDefinition = {
  flow: AssetWizardFlow.FINE_ART,
  label: 'Fine art and collectables',
  icon: Gem,
  schema: fineArtSchema,
  steps: [
    {
      key: OWNERSHIP_STEP_KEY,
      label: 'Investing or holding',
      heading: 'Where is this held?',
      description: 'A piece is held by a person, trust or company. Pick that account, or create it here.',
      component: OwnershipStep,
      fields: ownerAccountFields(),
    },
    {
      key: 'piece',
      label: 'Piece',
      heading: 'What is this?',
      description:
        'Paintings, sculpture, jewellery and wine all go here — anything held for itself rather than for yield.',
      fields: [
        assetNameField('Name of the piece', 'Name this piece'),
        descriptionField(),
      ],
    },
    {
      key: 'purchase',
      label: 'Purchase',
      heading: 'How much did you pay?',
      description: 'Record the purchase of this piece.',
      fields: [
        amountField('Cost'),
        dateField('Date of purchase'),
        currencyField(),
      ],
    },
    VALUE_STEP,
    TAGS_STEP,
    SUMMARY_STEP,
  ],
  /*
   * One record, as the loan draws it. The account it hangs off used to be a
   * card of its own here, because the flow created one every time; now it is
   * usually an account that already exists, and the summary states it once
   * across the top — see SummaryAccount.
   */
  records: [
    {
      key: 'piece',
      label: 'Piece',
      icon: Gem,
      tone: 'brand',
      transactionType: 'add position',
      heading: 'assetName',
      fields: ['amount', 'date', 'currency', 'description'],
    },
  ],
  constants: { assetType: FINE_ART_TYPE },
  defaultTags: DEFAULT_TAGS,
  create,
}
